
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'MatchingProductPdp',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      productObject: null,
      isTabletOrDesktop: false,
      isMobile: this.$store.state.ui.cartPopupOpenMobile,
      isDesktop: this.$store.state.ui.cartPopupOpenDesktop,
      buttonText: this.$t('Size_Selector_Buy'),
    }
  },
  computed: {
    ...mapGetters({
      cart: 'centra-cart/cart',
      getProductById: 'centra-product/getProductById',
      currentMarketId: 'frontend/currentMarketId',
      currentPricelistId: 'frontend/currentPricelistId'
    }),
    ...mapState({
      addToCartLoadingItemPDP: state => state.ui.addToCartLoadingMatchingProductsPDP,
    }),
    sizeOptions () {
      return this.centraProduct?.sizeOptions || []
    },
    isGiftcard () {
      return this.product && this.product.variantName === 'Giftcard'
    },
  },
  watch: {
    addToCartLoadingItemPDP (newVal) {
      if (newVal === this.product.product) {
        this.buttonText = this.$t('Product_Details_Matching_Products_PDP')
        setTimeout(() => {
          this.buttonText = this.$t('Size_Selector_Buy')
        }, 2000)
      }
    }
  },
  mounted () {
    this.setViewport()
    window.addEventListener('resize', this.setViewport)
  },
  destroyed () {
    window.removeEventListener('resize', this.setViewport)
  },
  created () {
    this.prepareProductLookup(this.product.product)
    if (this.product.isBundle) {
      this.fetchCentraProduct(this.product.sku)
    }
  },
  methods: {
    async prepareProductLookup (id) {
      await this.$store.dispatch('centra-product/lookupProducts', id)
      this.productObject = this.transformProduct(this.$store.getters['centra-product/getProductById'](id))
    },
    async fetchCentraProduct (productSku) {
      if (this.centraProduct !== null) {
        return
      }
      await this.$store.dispatch('centra-product/lookupProductBySku', productSku)
        .then((productObject) => {
          this.centraProduct = productObject
        })
        .catch((error) => {
          console.error('Failed to fetch centra product', error)
          this.centraProduct = {}
        })
    },
    productPrices (product) {
      return {
        price: product.price,
        priceBeforeDiscount: product.price !== product.priceBeforeDiscount ? product.priceBeforeDiscount : null
      }
    },
    hideSidebar () {
      if (this.isMobile) {
        this.$store.dispatch('ui/hideCartPopupMobile')
      } else if (this.isDesktop) {
        this.$store.dispatch('ui/hideCartPopupDesktop')
      }
    },
    setViewport () {
      this.isTabletOrDesktop = window.innerWidth >= 768
      this.isMobile = window.innerWidth < 768
    },
    handleAtcClick () {
      if (this.productObject.sizeOptions.length) {
        this.showSizeSelector()
      } else {
        this.fetchCentraProduct(this.productObject.sku).then(() => {
          if (this.sizeOptions.length) {
            this.showSizeSelector()
          }
        })
      }
    },
    showSizeSelector () {
      if (this.isTabletOrDesktop) {
        this.$store.dispatch(
          'ui/showSizeSelectorDesktop',
          {
            productID: this.productObject.product,
            discontinued: false,
          }
        )
      } else {
        this.$store.dispatch(
          'ui/showSizeSelectorMobile',
          {
            productID: this.productObject.product,
            discontinued: false,
          }
        )
      }
    }
  }
}
